import {
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogClose,
  Typography,
  Button,
  Dialog,
} from '@ui/components';
import { useMutation } from '@tanstack/react-query';
import { resetOnboarding } from '@api/onboarding';
import { useNavigate } from 'react-router-dom';
import { Routes } from '@shared/enums';
import { t } from 'i18next';
import { FC } from 'react';

interface RemoveImportModalProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export const RemoveImportModal: FC<RemoveImportModalProps> = (props) => {
  const { onOpenChange, open } = props;
  const navigate = useNavigate();

  const { mutate, isPending } = useMutation({
    mutationFn: resetOnboarding,
    onSuccess: () => {
      navigate(`../${Routes.ADD_VEHICLES}`);
    },
  });

  const onRemove = () => {
    navigate(`../${Routes.IMPORT_REMOVAL}`);
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('ONBOARDING.IMPORT_SUMMARY.REMOVE_IMPORT_MODAL.TITLE')}</DialogTitle>
        </DialogHeader>

        <div className="p-4">
          <Typography variant="paragraphBasicBook">
            {t('ONBOARDING.IMPORT_SUMMARY.REMOVE_IMPORT_MODAL.DESCRIPTION')}
          </Typography>

          <Button
            onClick={() => mutate()}
            isLoading={isPending}
            disabled={isPending}
            className="px-0"
            variant="link"
          >
            {t('ONBOARDING.IMPORT_SUMMARY.REMOVE_IMPORT_MODAL.REMOVE_AND_ADD_MANUALLY')}
          </Button>
        </div>

        <DialogFooter className="grid grid-cols-2 gap-3">
          <DialogClose asChild>
            <Button disabled={isPending} variant="tertiary">
              {t('ONBOARDING.IMPORT_SUMMARY.REMOVE_IMPORT_MODAL.CANCEL')}
            </Button>
          </DialogClose>
          <Button disabled={isPending} onClick={onRemove}>
            {t('ONBOARDING.IMPORT_SUMMARY.REMOVE_IMPORT_MODAL.REMOVE_IMPORT')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
